var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-row pricing-row" }, [
    !_vm.showMobileVersion
      ? _c("div", { staticClass: "td order-lg-0" })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "td text-truncate order-0 order-lg-1" }, [
      _c("span", { staticClass: "mobile-title mr-2" }, [_vm._v("Name:")]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "text-truncate pr-4",
          attrs: { title: _vm.name },
          on: { click: _vm.goToCampPricing }
        },
        [_vm._v("\n                " + _vm._s(_vm.name) + "\n            ")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "td order-2 order-lg-2" }, [
      _vm.schoolCountry === "England"
        ? _c("span", { staticClass: "mobile-title mr-2" }, [
            _vm._v("Age/Years:")
          ])
        : _c("span", { staticClass: "mobile-title mr-2" }, [
            _vm._v("Age/Grades:")
          ]),
      _vm._v("\n            " + _vm._s(_vm.range) + "\n        ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "td order-3 order-lg-3" }, [
      _c("span", { staticClass: "mobile-title mr-2" }, [_vm._v("Time:")]),
      _vm._v(
        _vm._s(_vm.formatTime(_vm.timeFrom)) +
          " - " +
          _vm._s(_vm.formatTime(_vm.timeTo))
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "td order-1 order-lg-4" }, [
      _c("span", { staticClass: "mobile-title mr-2" }, [_vm._v("Price:")]),
      _vm._v(
        _vm._s(_vm.currencySign) +
          " " +
          _vm._s(_vm._f("priceFormat")(_vm.price))
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "td order-4 order-lg-5" }, [
      _c("span", { staticClass: "mobile-title mr-2" }, [_vm._v("Enrolled:")]),
      _vm._v(_vm._s(_vm.enrolled) + " / " + _vm._s(_vm.maxEnroll))
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "td order-5 order-lg-6" },
      [
        _c("span", { staticClass: "mobile-title mr-2" }, [_vm._v("Status:")]),
        _vm._v(" "),
        _c("activity-status", { attrs: { status: _vm.activityStatus } })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b76e111a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b76e111a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/pages/camps/CampPricingRow.vue
// module id = null
// module chunks = 